<h2 mat-dialog-title>{{ data?.id ? ("learning_section_edit" | transloco) : ("learning_section_create" | transloco) }}
</h2>
<div class="pixl-form">
    <mat-divider></mat-divider>

    <mat-tab-group>
        <mat-tab [label]="'base_data' | transloco">
            <mat-dialog-content
                [formGroup]="form"
                class="grid"
            >
                <mat-form-field>
                    <mat-label>{{ "name" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="name"
                    />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ "title" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="title"
                    />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ "type" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="learningSectionType"
                    />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ "layout" | transloco }}</mat-label>
                    <mat-select formControlName="learningSectionLayout">
                        @for (learningSectionLayout of learningSectionLayouts$ | async; track learningSectionLayout.id)
                        {
                        <mat-option [value]="learningSectionLayout.id">{{ learningSectionLayout.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ "application" | transloco }}</mat-label>
                    <mat-select formControlName="consumer">
                        @for (consumer of consumers$ | async; track consumer.id) {
                        <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ "subjects_professions" | transloco }}</mat-label>
                    <mat-select
                        formControlName="subjects"
                        multiple
                    >
                        @for (subject of subjects$ | async; track subject.id) {
                        <mat-option [value]="subject.id">{{ subject.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <div class="full-width">
                    <pixl-multi-combo-entity-search
                        [label]="learningUnitLabel"
                        [observable$]="learningUnits$"
                        [namingColumn]="'title'"
                        [externalSearch]="true"
                        (onStateChange)="receiveLearningUnitData($event)"
                        (onSearchChange)="receiveLearningUnitQuery($event)"
                        (scrolledToEnd)="loadMoreLearningUnits($event)"
                        [(selectedValues)]="selectedLearningUnits"
                    >
                    </pixl-multi-combo-entity-search>
                </div>

                <mat-slide-toggle
                        formControlName="is_mandatory"
                        labelPosition="after"
                        class="slide-toggler"
                >
                    {{ (form.get('is_mandatory')?.value ? 'is_mandatory' : 'voluntary') | transloco }}
                </mat-slide-toggle>

                <mat-slide-toggle
                        formControlName="showCopyright"
                        labelPosition="after"
                        class="slide-toggler"
                >
                    {{ "copyright_notice_images" | transloco }}
                </mat-slide-toggle>

            </mat-dialog-content>
        </mat-tab>
        <mat-tab [label]="(selectedConsumerName$ | async) || ('metadata' | transloco)">
            <mat-dialog-content class="grid">
                <pixl-object-consumer-metadata
                    [parentForm]="form"
                    [objectType]="'learning_section'"
                ></pixl-object-consumer-metadata>
            </mat-dialog-content>
        </mat-tab>
    </mat-tab-group>
    <br />
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button
            mat-button
            (click)="cancel()"
        >{{ "cancel" | transloco }}</button>
        <button
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="form.invalid"
        >{{ "save" | transloco }}</button>
    </mat-dialog-actions>
</div>